import {OPEN_SNACK, OPEN_SNACK_LOADING, CLOSE_SNACK} from './type.action';

export const openSnack = (snackInfo) => {
  return { type: OPEN_SNACK, payload: snackInfo };
};

export const openSnackLoading = (snackInfo) => {
  return { type: OPEN_SNACK_LOADING, payload: snackInfo };
};

export const closeSnack = () => {
  return { type: CLOSE_SNACK };
};